var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"basic_wrap"},[_c('bsHeader',{attrs:{"title":_vm.data.title}}),_c('div',{staticClass:"p_agr",domProps:{"innerHTML":_vm._s(_vm.data.content)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }